import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import type { LC_SaveGroupEmployeesIn } from '../types/groupEmployees.types';


export class GroupEmployeesSaveService {
  async save(
    groupId: number,
    body: LC_SaveGroupEmployeesIn,
  ): Promise<ApiResponse<void>> {
    return apiClient.put<void>(
      API_CONFIG.ENDPOINTS.SECURITY_GROUPING.EMPLOYEES(groupId),
      body,
    );
  }
}

export const groupEmployeesSaveService = new GroupEmployeesSaveService();
